module.exports = __webpack_public_path__ + "img/item-certificate.aa264131.svg";